<div class="quantity">
  <div fxLayout="row">
      <button style="font-size: 18px;" [ngStyle]="{'color': color}" class="quantity-button-left" (click)="onSubstractQuantity($event)">-</button>
      <input class="selected-quantity" [value]="selectedQuantity" matInput type="number" min="0"oninput="this.value = Math.abs(this.value)" (keyup)="onKey($event)" />
      <button style="font-size: 18px;" [ngStyle]="{'color': color}" class="quantity-button-right" (click)="onAddQuantity($event)">+</button>
  </div>
</div>
